import { render, staticRenderFns } from "./HomeAppItem.vue?vue&type=template&id=03c46450&scoped=true&"
import script from "./HomeAppItem.vue?vue&type=script&lang=ts&"
export * from "./HomeAppItem.vue?vue&type=script&lang=ts&"
import style0 from "./HomeAppItem.vue?vue&type=style&index=0&id=03c46450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c46450",
  null
  
)

export default component.exports